/**
 * Demo test papers used when the API returns no published papers.
 * Always exposes the five core ability papers on the grid.
 */
import { getCoreAbilityPapers } from './abilityPapers.js';

export const DEMO_QUESTIONNAIRE_PAPERS = getCoreAbilityPapers();
